import React, { useCallback } from 'react';
import useFromAmount from '../../hooks/use-from-amount.js';
import useResetForm from '../../hooks/use-reset-form.js';
import useSwapMode from '../../hooks/use-swap-mode.js';
import useToAmount from '../../hooks/use-to-amount.js';
import usePrefilledAmountId from '../../hooks/use-prefilled-amount-id.js';
const ResetButton = ({ Component, className, style, onPress }) => {
    const [swapMode] = useSwapMode();
    const [fromAmount] = useFromAmount();
    const [toAmount] = useToAmount();
    const [prefillAmountId] = usePrefilledAmountId();
    const resetForm = useResetForm();
    const visible = swapMode === 'ExactIn' ? fromAmount.isPositive : toAmount.isPositive || !!prefillAmountId;
    const handlePress = useCallback(() => {
        onPress?.();
        resetForm();
    }, [onPress, resetForm]);
    if (Component) {
        return React.createElement(Component, { visible: visible, className: className, style: style, onPress: handlePress });
    }
    return null;
};
export default ResetButton;
